import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "evrideo-full-screen-icon",
  templateUrl: "./full-screen-icon.component.html",
  styleUrls: ["./full-screen-icon.component.scss"],
})
export class FullScreenIconComponent implements OnInit {
  @Input()
  overrideStyle = {};
  constructor() {}

  ngOnInit(): void {}
}
